 <template >
  <el-form ref="footerForm" :model="footerForm" :rules="commonRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item prop="deviceIp" label="设备IP">
          <el-input
            v-if="!isDetail()"
            v-model.trim="footerForm.deviceIp"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ footerForm.deviceIp || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item prop="lng" label="经度">
          <el-input
            v-if="!isDetail()"
            v-model.trim="footerForm.lng"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ footerForm.lng || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="lat" label="纬度">
          <el-input
            v-if="!isDetail()"
            v-model.trim="footerForm.lat"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ footerForm.lat || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item prop="fileIdList" label="附件">
          <UploadImg
            :isDetail="isDetail()"
            :defaultList="defaultList"
            :limitNum="9"
            @get-file-data="getImgIdList"
          />
          <span v-if="!defaultList.length && isDetail()">{{ '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item prop="remark" label="备注">
          <el-input
            v-if="!isDetail()"
            v-model.trim="footerForm.remark"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ footerForm.remark || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import UploadImg from '@/components/UploadImgNew';
export default {
  components: {
    UploadImg
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    // 经度校验
    const validateLng = (rule, value, callback) => {
      const lngReg =
        /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
      if (!value) {
        callback();
        return;
      }
      if (!lngReg.test(value)) {
        callback(new Error('请输入正确的经度值'));
      } else {
        callback();
      }
    };
    // 纬度校验
    const validateLat = (rule, value, callback) => {
      const latReg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
      if (!value) {
        callback();
        return;
      }
      if (!latReg.test(value)) {
        callback(new Error('请输入正确的纬度值'));
      } else {
        callback();
      }
    };
    return {
      defaultList: [],
      agreementList: [],
      parameterList: [],
      footerForm: {},
      commonRules: {
        lng: [{ required: false, validator: validateLng, trigger: 'blur' }],
        lat: [{ required: false, validator: validateLat, trigger: 'blur' }]
      }
    };
  },
  inject: ['isDetail'],
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.footerForm = newVal;
      }
    },
    footerForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  methods: {
    reset() {
      this.$refs.footerForm.resetFields();
      this.defaultList = [];
    },
    validate() {
      let type;
      this.$refs.footerForm.validate(validated => {
        type = validated;
      });
      return type;
    },
    getData() {
      const { deviceIp, lng, lat, fileIdList, remark } = this.footerForm;
      let data = {
        deviceIp,
        lng,
        lat,
        fileIdList,
        remark
      };
      return data;
    },
    setData(data) {
      const { deviceIp, lng, lat, fileInfoList, remark } = data;
      this.footerForm.deviceIp = deviceIp;
      this.footerForm.lng = lng;
      this.footerForm.lat = lat;
      this.footerForm.remark = remark;
      this.defaultList = fileInfoList.map(item => {
        return {
          url: item.fileUrl,
          name: item.fileOriginName,
          data: item.fileId
        };
      });
      this.footerForm.fileIdList = fileInfoList.map(item => {
        return item.fileId;
      });
    },
    getImgIdList(idList) {
      this.footerForm.fileIdList = idList;
    }
  }
};
</script>